var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBracketsX = function SvgBracketsX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7c76d80a-25e6-41c0-ba5c-1e766e6ba0baa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000713",
    fillRule: "evenodd",
    d: "M1.629 4.19c0-1.21.98-2.19 2.19-2.19a.667.667 0 0 1 0 1.333.857.857 0 0 0-.857.858v3.047c0 .177-.07.346-.195.471L2.477 8l.29.29a.67.67 0 0 1 .195.472v3.047c0 .474.384.858.857.858a.667.667 0 1 1 0 1.333 2.19 2.19 0 0 1-2.19-2.19V9.037l-.567-.567a.667.667 0 0 1 0-.942l.567-.567zm10.285-1.523c0-.369.298-.667.667-.667 1.21 0 2.19.98 2.19 2.19v2.772l.567.567c.26.26.26.682 0 .942l-.567.567v2.771A2.19 2.19 0 0 1 12.581 14a.667.667 0 0 1 0-1.333.857.857 0 0 0 .857-.858V8.762c0-.177.07-.346.195-.471l.29-.291-.29-.29a.67.67 0 0 1-.195-.472V4.191a.857.857 0 0 0-.857-.858.667.667 0 0 1-.667-.666M5.729 5.529c.26-.26.682-.26.942 0L8.2 7.057 9.729 5.53a.667.667 0 1 1 .942.942L9.143 8l1.528 1.529a.667.667 0 1 1-.942.942L8.2 8.943 6.671 10.47a.667.667 0 1 1-.942-.942L7.257 8 5.73 6.471a.667.667 0 0 1 0-.942",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7c76d80a-25e6-41c0-ba5c-1e766e6ba0baa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.2 0h16v16H.2z"
  })))));
};
export default SvgBracketsX;